import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

@Directive({
    selector: '[appHoraMinutoValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: HoraMinutoValidatorDirective,
        multi: true
    }]
})
export class HoraMinutoValidatorDirective implements Validator {

    validate(control: AbstractControl): { [key: string]: any } | null {
        if (!this.duracaoValidator(control.value)) {
            return { 'horaMinutoInvalid': true };
        }
        return null;
    }

    duracaoValidator(valor: string): boolean {
        // Aceita valores como 0:00 até 999:59
        const regex = /^\d{1,3}:[0-5]\d$/;
        return regex.test(valor);
    }
}